export default "__VITE_ASSET__53RQPfOg__"